var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('item-detail-base',{attrs:{"item-title":"社会责任"}},[_c('div',{staticClass:"social-title"},[_c('span',[_vm._v("社会责任")])]),(_vm.Des && _vm.Img)?_c('content-base-item',{attrs:{"content-des":_vm.Des,"content-img":_vm.Img}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }